import React from "react";
import { useSelector } from "react-redux";


import { RefundTablePage } from "./refundTable/RefundTablePage";
import { RefundFilterPage } from "./refundFilter/RefundFilterPage";



import classes from "./refundPage.module.css";
import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { selectRefundState } from "../../store/refundFilterSlice";
import { selectRefunds, useGetRefundListQuery } from "../../services/refundApiSlice";


export const RefundPage = () => {
  const appliedFilters = useSelector(selectRefundState);
  const { isSuccess } = useGetRefundListQuery(appliedFilters);

  const tableData = useSelector(selectRefunds);

  return isSuccess ? (
    <div className={classes.box}>
      <RefundFilterPage filters={appliedFilters} />
      <RefundTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
